import { graphql } from '@gql';

export const COMMENT_FRAGMENT = graphql(`
    fragment Comment on ProjectZoneStandardProfileRequirementComment {
        id
        createTime
        comment
        requirementCommentStatus
        user {
            id
            firstName
            lastName
        }
    }
`);

export const CREATE_COMPONENT_REQUEST_VIEW_FRAGMENT = graphql(`
    fragment CreateComponentRequestViewFragment on ComponentCreateRequestView {
        id
        componentID
        componentName
        componentVersion
        componentVendorName
        componentVendorID
        requestPriority
        userID
        requesterID
        referenceWeb
        referenceSecurity
        statusID
        statusCode
        sourceID
        externalRequestRef
        externalComponentID
        externalRequestStatus
        comments {
            ...CreateComponentRequestComment
        }
    }
`);

export const STATUS_TRANSITIONS_FRAGMENT = graphql(`
    fragment CreateComponentRequestStatusTransition on ComponentCreateRequestViewAllowedStatusTransition {
        id
        code
        blocked
        reason
    }
`);

export const COMMENTS_FRAGMENT = graphql(`
    fragment CreateComponentRequestComment on ComponentCreateRequestViewComment {
        comment
        userID
        createTime
    }
`);

export const CREATE_COMPONENT_REQUEST = graphql(`
    fragment CreateComponentRequestFragment on ComponentCreateRequest {
        id
        componentID
        componentName
        componentVersion
        componentVendorName
        componentVendorID
        requestPriority
        userID
        referenceWeb
        referenceSecurity
        statusID
        sourceID
        externalRequestRef
        externalComponentID
        externalRequestStatus
    }
`);

export const CREATE_COMPONENT_REQUEST_VIEW = graphql(`
    fragment CreateComponentRequestView on ComponentCreateRequestView {
        ...CreateComponentRequestViewFragment
        statusTransitions {
            ...CreateComponentRequestStatusTransition
        }
        comments {
            ...CreateComponentRequestComment
        }
    }
`);
